import React, { useState, useRef, useEffect } from 'react';
import Transition from '../../../src/utils/Transition';

function SingleSelectWithSearch(props) {

  var options = [
    {
      id: 0,
      name: ''
    }
  ];

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selected, setSelected] = useState(props.value);

  if (props.optionArray !== undefined) {
    if (props.optionArray.length > 0) {
      options = options.concat(props.optionArray);

    }
  }

  const trigger = useRef(null);
  const dropdown = useRef(null);

  useEffect(() => {
    setSelected(props.value);
  }, [props.value])
  

  useEffect(() => {

    const clickHandler = ({ target }) => {
      if (!dropdown.current) return;
      if (!dropdownOpen || dropdown.current.contains(target) || trigger.current.contains(target)) return;
      setDropdownOpen(false);
    };
    document.addEventListener('click', clickHandler);
    return () => document.removeEventListener('click', clickHandler);
  });

  // close if the esc key is pressed
  useEffect(() => {
    const keyHandler = ({ keyCode }) => {
      if (!dropdownOpen || keyCode !== 27) return;
      setDropdownOpen(false);
    };
    document.addEventListener('keydown', keyHandler);
    return () => document.removeEventListener('keydown', keyHandler);
  });

  const setFilterParameters = (id, name, drpIdentity) => {
    props.setFilterParameters(id, name, drpIdentity);
  }
  return (

    <div className="relative inline-flex w-full common-input-dropdown" key={props.drpIdentity}>

      {props.disabled ?
        <input
          className="w-full drop-input"
          type="text"
          id="TestCompo"
          name="TestCompo"
          // onChange={(event) => this.handleChange(event)}
          // onBlur={() => this.validateField("metaTitle")}
          value={props.searchText}
          onClick={() => { setDropdownOpen(!dropdownOpen); setSelected(options.find(option => option.id === Number(props.value)).id) }}
          ref={trigger}
          onChange={(e) => props.handleChangeTest(e, props.drpIdentity)}
          autoComplete="off"
        />
        :
        <input
          className="w-full drop-input"
          type="text"
          id="TestCompo"
          name="TestCompo"
          value={props.searchText}
          onFocus={() => { setDropdownOpen(!dropdownOpen); setSelected(options.find(option => option.id === Number(props.value)).id) }}
          ref={trigger}
          onChange={(e) => props.handleChangeTest(e, props.drpIdentity)}
          autoComplete="off"
        />
      }

      <Transition
        show={dropdownOpen}
        tag="div"
        className="dropdown-option-section-list z-10 absolute top-full left-0 w-full bg-white border border-slate-200 py-1.5 rounded shadow-lg overflow-x-hidden overflow-y-auto  mt-1 break-words"
        enter="transition ease-out duration-100 transform"
        enterStart="opacity-0 -translate-y-2"
        enterEnd="opacity-100 translate-y-0"
        leave="transition ease-out duration-100"
        leaveStart="opacity-100"
        leaveEnd="opacity-0"
      >
        <div
          ref={dropdown}
          className="font-medium text-sm text-slate-600"
          onFocus={() => setDropdownOpen(true)}
          onBlur={() => setDropdownOpen(false)}
        >
          {
            options.map(option => {
              return (
                <button
                  key={option.id}
                  tabIndex="0"
                  className={`flex items-center w-full hover:bg-slate-50 py-1 px-3 cursor-pointer ${option.id === selected && 'hover-active-color'}`}
                  onClick={(event) => { setSelected(option.id); setDropdownOpen(false); setFilterParameters(option.id, option.name, props.drpIdentity) }}
                >
                  <svg className={`shrink-0 mr-2 fill-current theme-text-color ${option.id !== selected && 'invisible'}`} width="12" height="9" viewBox="0 0 12 9">
                    <path d="M10.28.28L3.989 6.575 1.695 4.28A1 1 0 00.28 5.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28.28z" />
                  </svg>
                  <span className='theme-text-color'>{option.name}</span>
                </button>
              )
            })
          }
        </div>
      </Transition>
    </div>
  );
}

export default SingleSelectWithSearch;
